import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleResource from "@/store/resource/moduleResource.js";
import FloatingButtons from "@/views/FloatingButtons.vue";
import Resource from "@/models/Resource";
import Api from "@/helpers/api.js";

export const ResourceMixin = {
	name: "ResourceCreate",
	components: {
		vSelect,
		flatPickr,
		FloatingButtons,
	},
	data() {
		return {
			resource: new Resource({}),
			showPromptField: false,
			propertiesList: [],
			statusOptions: [],
			rolOptions: [],
			propertiesObject: {},
			statusObject: {label: "", value: ""},
			rolObject: {label: "", value: ""},
			isUpdate: false,
			indexUpdate: null,
			configdateTimePicker: {
				enableSeconds: true,
				enableTime: true,
				noCalendar: true,
			},
			property: {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			},
			type: [
				{
					label: "Text",
					value: "text",
				},
				{
					label: "Date",
					value: "date",
				},
				{
					label: "Time",
					value: "time",
				},
				{
					label: "Number",
					value: "number",
				},
			],
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any();
		},
		validFormAdditionalFields() {
			return this.property.label.length > 0 && this.property.value.length > 0;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		generateOptionSelect(data, propLabel, propValue) {
			if (!Array.isArray(data)) {
				return [];
			}
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		save_changes() {
			if (!this.validateForm) return;
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (!this.validateForm) return;
					this.registerResource();
				} else {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("VisitPoints.ValidData.Text"),
						time: 6000,
					});
				}
			});
		},
		registerResource() {
			this.resource["role_id"] = this.rolObject ? this.rolObject.value : 2;
			this.resource["status_id"] = this.statusObject
				? this.statusObject.value
				: this.statusOptions.map((data) => data.name === "ACTIVE")[0].id;
			this.resource["additional_info"] = this.propertiesObject || {};
			this.resource["json_properties"] = this.propertiesList || {};
			delete this.resource.id;
			this.$store
				.dispatch("moduleResource/addResource", this.resource)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("ResourceModule.Create.SuccessText"),
						text: this.$t("Record.TextConfirmRecordCreate"),
					});
					this.resource = new Resource({});
					this.$router.push({name: "app-resources-list"});
				})
				.catch((error) => {
					console.warn(error);
					this.validateErrorRegister(error.data);
				});
		},
		validateErrorRegister(error) {
			console.error(error);

			if (error === null || error === undefined) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("VisitPoints.ErrorRegisterValidate.Title"),
					text: this.$t("VisitPoints.ErrorRegisterValidate.Text"),
				});
				return;
			} else if (error.hasOwnProperty("reason")) {
				let title = "";
				let text = "";
				switch (error.reason) {
					case "username already registered":
						title = this.$t("MODULE_SOURCE.User_name");
						text = this.$t("ResourceModule.Edit.Error.Username");
						break;
					case "email already registered":
						title = this.$t("MODULE_SOURCE.Email");
						text = this.$t("ResourceModule.Edit.Error.Email");
						break;
					case "identification already registered":
						title = this.$t("Routing.Table.Identification");
						text = this.$t("ResourceModule.Edit.Error.Id");
						break;
				}
				this.$vs.notify({
					color: "danger",
					title,
					text,
					time: 8000,
				});
			}
			if (error.hasOwnProperty("error") && error.error.length > 0) {
				if (error.error[0].absolute_path[0] === "identification") {
					this.$vs.notify({
						color: "danger",
						title: this.$t("VisitPoints.ValidData.Title"),
						text: this.$t("ManualData.identification") + ": " + this.$t("ManualData.AlreadyRegistered"),
						time: 7000,
					});
				}
			}
		},
		addProperty(property) {
			let findOther = this.propertiesList.findIndex((elem) => elem.label === property.label);
			if (findOther == -1) {
				this.propertiesList.push(property);
				this.propertiesObject[property.label] = property.value;
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else if (this.isUpdate) {
				this.updateProperty(property);
				this.property = {
					label: "",
					type: {
						label: "Text",
						value: "text",
					},
					value: "",
				};
				setTimeout(() => {
					this.errors.clear();
				}, 20);
			} else {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Alert"),
					text: this.$t("ResourceModule.Messages.AddProperties.Error.Text2"),
				});
			}
		},
		deleteItem(data, indexItem) {
			this.propertiesList.splice(indexItem, 1);
			delete this.propertiesObject[data.label];
		},
		editSelect(val, index) {
			this.isUpdate = true;
			this.showPromptField = true;
			this.property.label = val.label;
			this.property.value = val.value;
			this.property.type = val.type;
			this.indexUpdate = index;
		},
		updateProperty(property) {
			this.propertiesList[this.indexUpdate].label = property.label;
			this.propertiesList[this.indexUpdate].value = property.value;
			this.propertiesList[this.indexUpdate].type = property.type;
			this.propertiesObject[property.label] = property.value;
		},
		showPrompt() {
			this.showPromptField = true;
			this.isUpdate = false;
			this.property = {
				label: "",
				value: "",
				type: {
					label: "Text",
					value: "text",
				},
			};
		},
		validateKeyAdditionalInfo(event) {
			let regex = /^[a-zA-Z_]\w*$/;
			let key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
			if (!regex.test(key)) {
				event.preventDefault();
				return false;
			}
		},
		async getStatus() {
			try {
				this.openLoading();
				const result = await Api.get("/status");
				this.statusOptions = this.generateOptionSelect(result.data, "name", "id");
				this.closeLoading();
			} catch (e) {
				this.closeLoading();
				console.error(e);
			}
		},
		async getRol() {
			try {
				this.openLoading();
				const result = await Api.get("/role");
				this.rolOptions = this.generateOptionSelect(
					result.data.filter((data) => data.name === "ADMIN" || data.name === "GOTU"),
					"name",
					"id"
				);
				this.closeLoading();
			} catch (e) {
				this.closeLoading();
				console.error(e);
			}
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		this.getRol();
		this.getStatus();
	},
};
